import { pickKeys } from '../apiTransformers/transformers';
/**
 * PickResponseKeys decorator - selects desired fields from API payload and passes them to client side
 * Requires an additional parameter (array of keys) passed as an array (string[])
 * @param function
 * @returns function
 ```
  import { PickResponseKeys } from '../../_decorators';

  @PickResponseKeys
  getVehicleSummary(vehicleVin: string): Promise<Component[]> {

  ```
 */
export function PickResponseKeys(target, propertyName, propertyDescriptor) {
    const method = propertyDescriptor.value;
    propertyDescriptor.value = (...args) => {
        return method
            .apply(target, args)
            .then((response) => {
            return pickKeys(response, args, propertyName);
        });
    };
    return propertyDescriptor;
}
